import React, { useEffect, useState } from "react";
import Homeimage from "./Homeimage";
import SimpleSlider from "./SimpleSlider";
import MarqueeLabel from "./MarqueeLabel";
import Homeprocess from "./Homeprocess";
import Carousal from "./Carousal";
import CarTypeSection from "./CarTypeSection";
import RentCar from "./RentCar";
import { useDispatch, useSelector } from "react-redux";
import { getFavcars } from "../../redux/Slice/configSlice";
import { getUserDetail } from "../../redux/Slice/authSlice";
import { fetchUserBooking, getLocation } from "../../redux/Slice/bookingSlice";
import { getCarMake, getCarModal } from "../../redux/Slice/formSlice";
import { filterCars, getAllCars } from "../../redux/Slice/carSlice";
import MapComponent from "../Google map/MapComponent";
// import { getCars } from '../../redux/formSlice'
// import { getCategories } from '../../redux/Slice/configSlice'
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
const Index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  const signinDetail = useSelector((state) => state?.auth?.signupDetail);
  const [isChecked, setIsChecked] = useState(() => {
    const savedValue = sessionStorage.getItem("isChecked");
    return savedValue ? JSON.parse(savedValue) : false;
  });
  useEffect(() => {
    dispatch(getFavcars());
    dispatch(getLocation());
    dispatch(getCarMake());
    dispatch(getCarModal());
    dispatch(fetchUserBooking({ userId: userDetail?.data?._id }));
    // dispatch(getAllCars());
    // dispatch(
    //   filterCars({
    //     filterQuery: {
    //       carType: [],
    //       carmaker: [],
    //       carmodel: [],
    //       numberOfSeats: [],
    //     },
    //     userId: userDetail?.data?._id,
    //     userLat: "",
    //     userLong: "",
    //     pickUpDateandTime: "",
    //     returnDateandTime: "",
    //     withDriver: isChecked,
    //     price: 1,
    //   })
    // );

    if (loginDetail) {
      dispatch(getUserDetail(loginDetail));
    }
  }, [loginDetail]);
  useEffect(() => {
    const missingFields = [];
    if (Object.keys(userDetail)) {
      if (userDetail?.data && Object.keys(userDetail?.data)?.length) {
        if (!userDetail?.data.image) missingFields.push("Profile photo");
        if (!userDetail?.data.address) missingFields.push("Address");
        if (!userDetail?.data.identityFront)
          missingFields.push("Identity card front side");
        if (!userDetail?.data?.identityBack)
          missingFields.push("Identity card back side");
        // if (!userDetail?.data.drivingLicenseFront)
        //   missingFields.push("Driving card front side");
        if (missingFields.length > 0) {
          // Join missing fields into a message
          const missingFieldsMessage = missingFields.join(", ");

          // Show SweetAlert with a specific message for missing fields
          Swal.fire({
            title: "Please complete your profile first!",
            text: `You need to complete the following fields: ${missingFieldsMessage}`,
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "OK",
            customClass:{
              confirmButton: 'btn img-btn',
            }
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/edit-profile");
              scrollToTop()
              // Redirect the user to the profile page
              // history.push('/profile'); // or `navigate('/profile')` in React Router v6+
            }
          });
        }
      }
    }
  }, []);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // useEffect(() => {
  //   dispatch(getAllCars());
  // }, []);

  return (
    <div>
      {/* <Homeimage /> */}
      {/* <MapComponent /> */}
      <MarqueeLabel />
      <SimpleSlider />
      <Carousal />
      <Homeprocess />
      <RentCar />
      <CarTypeSection />
    </div>
  );
};

export default Index;
